import React from 'react';
import { emptyTranslation } from '@colonist/i18n';
import { Dialog, Image, T, Tooltip, useTranslation } from '@colonist/ui';
import styles from './BecomeMemberDialog.module.scss';
import IconNoAds from '@static/images/icon_no_ads.svg';
import IconFullScreenExpand from '@static/images/icon_fullscreen_expand.svg';
import IconColors from '@static/images/icon_colors.svg';
import IconCnKSeafarers from '@static/images/game_mode_icons/seafarers_cities_and_knights.svg';
import IconAllMaps from '@static/images/map_usa_preview.png';
import IconCnK from '@static/images/game_mode_icons/cities_and_knights.svg';
import IconInfo from '@static/images/icon_info.svg';
const DECORATIVE = emptyTranslation;
const BASIC_PERKS = [
    {
        image: {
            src: IconNoAds,
            alt: DECORATIVE
        },
        title: {
            key: 'strings:popups.becomeAMember.perks.noAds.title'
        },
        description: {
            key: 'strings:popups.becomeAMember.perks.noAds.description'
        }
    },
    {
        image: {
            src: IconFullScreenExpand,
            alt: DECORATIVE
        },
        title: {
            key: 'strings:popups.becomeAMember.perks.fullscreen.title'
        },
        description: {
            key: 'strings:popups.becomeAMember.perks.fullscreen.description'
        }
    },
    {
        image: {
            src: IconColors,
            alt: DECORATIVE
        },
        title: {
            key: 'strings:popups.becomeAMember.perks.colors.title'
        },
        description: {
            key: 'strings:popups.becomeAMember.perks.colors.description'
        }
    }
];
const GAMEPLAY_PERKS = [
    {
        image: {
            src: IconCnKSeafarers,
            alt: DECORATIVE
        },
        title: {
            key: 'strings:popups.becomeAMember.perks.allExpansions.title'
        },
        description: {
            key: 'strings:popups.becomeAMember.perks.allExpansions.description'
        }
    },
    {
        image: {
            src: IconAllMaps,
            alt: DECORATIVE
        },
        title: {
            key: 'strings:popups.becomeAMember.perks.allMaps.title'
        },
        description: {
            key: 'strings:popups.becomeAMember.perks.allMaps.description'
        }
    },
    {
        image: {
            src: IconCnK,
            alt: DECORATIVE
        },
        title: {
            key: 'strings:popups.becomeAMember.perks.rankedCK.title'
        },
        description: {
            key: 'strings:popups.becomeAMember.perks.rankedCK.description'
        }
    }
];
const PERKS_BY_TYPE = {
    basic: BASIC_PERKS,
    gameplay: GAMEPLAY_PERKS
};
export function BecomeMemberDialog({ open, onClose, onConfirm, type, price }) {
    const perks = PERKS_BY_TYPE[type];
    const { t, tArray } = useTranslation();
    const tooltipItems = tArray('strings:popups.becomeAMember.tooltip.body');
    const confirmButtonText = price ? {
        key: 'strings:popups.becomeAMember.buttonNames.subscribe'
    } : {
        key: 'strings:popups.becomeAMember.buttonNames.goToStore'
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:roomPage.becomeAMember'
        }
    }), /*#__PURE__*/ React.createElement(Tooltip, {
        title: t({
            key: 'strings:popups.becomeAMember.tooltip.title'
        }),
        content: /*#__PURE__*/ React.createElement("ul", {
            className: styles.tooltipList
        }, tooltipItems.map((item)=>/*#__PURE__*/ React.createElement("li", {
                key: item
            }, item))),
        extraWide: true
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.infoIcon,
        image: {
            src: IconInfo,
            alt: DECORATIVE
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.perks
    }, perks.map((perk)=>/*#__PURE__*/ React.createElement("div", {
            className: styles.perk,
            key: perk.title.key
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.perkImage,
            image: perk.image
        }), /*#__PURE__*/ React.createElement("h4", null, /*#__PURE__*/ React.createElement(T, {
            id: perk.title
        })), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(T, {
            id: perk.description
        }))))), price && /*#__PURE__*/ React.createElement("span", {
        className: styles.billing
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:storePage.sections.membership.billing.paidMonthly',
            options: {
                amount: price
            }
        }
    })))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onConfirm
    }, /*#__PURE__*/ React.createElement(T, {
        id: confirmButtonText
    }))));
}
